import Load from 'components/Load';
import React from 'react';
import { Route } from 'react-router-dom';
import basePath from 'utils/basePath';

const AsyncHostVideoModal = Load(
  () =>
    import(
      /* webpackChunkName: "host-video-modal" */ './containers/HostVideoModalContainer'
    ),
  {},
  true,
);
const AsyncInstantlyConfirmedModal = Load(
  () =>
    import(
      /* webpackChunkName: "how-it-works-modal-exp-page" */ 'components/HowItWorksModal/InstantlyConfirmedModal'
    ),
);
const AsyncFamilyFriendlyHowItWorks = Load(
  () =>
    import(
      /* webpackChunkName: "how-it-works-modal-exp-page" */ 'components/HowItWorksModal/FamilyFriendlyHowItWorks'
    ),
);

const ExperienceModalRoutes = [
  <Route
    key="experience.modal.video"
    path={`${basePath}/experience/:id/video/:hostId/`}
    component={AsyncHostVideoModal}
  />,
  <Route
    key="experience.modal.instantly-confirmed"
    path={`${basePath}/experience/instantly-confirmed/`}
    exact
    component={AsyncInstantlyConfirmedModal}
  />,
  <Route
    key="experience.modal.family-friendly"
    path={`${basePath}/experience/family-friendly/`}
    exact
    component={AsyncFamilyFriendlyHowItWorks}
  />,
];

export default ExperienceModalRoutes;
